export const enum SendToAxaptaStatus {
    PendingTransfer = 0,
    TransferCompleted = 1,
    SendToAxapta = 2,
    RequiredForCalculation = 3,
    All = 4,
}
